import script from "./SecSplit.vue?vue&type=script&setup=true&lang=js"
export * from "./SecSplit.vue?vue&type=script&setup=true&lang=js"

import "./SecSplit.vue?vue&type=style&index=0&id=069cc140&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069cc140"]])

export default __exports__